"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../../Utilities");
var ColorSlider_base_1 = require("./ColorSlider.base");
var ColorSlider_styles_1 = require("./ColorSlider.styles");
exports.ColorSlider = Utilities_1.styled(ColorSlider_base_1.ColorSliderBase, ColorSlider_styles_1.getStyles, undefined, { scope: 'ColorSlider' });
//# sourceMappingURL=ColorSlider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/ColorPicker/ColorSlider/ColorSlider.js
// module id = 832
// module chunks = 0